import { config } from './config';

export function parseBooleanish(value: boolean | string | null | undefined): boolean | null {
  return value == null ? null : value === true || value === 'true';
}

export const scrollToTop = () => {
  window.scrollTo(0, 0);
};

export const stageChecker = (consoleFunction: () => void) => {
  (config.isDev || config.isStg) && consoleFunction();
};
